import { render, staticRenderFns } from "./detailIngameFlat.vue?vue&type=template&id=37893a7c&scoped=true"
import script from "./detailIngameFlat.vue?vue&type=script&lang=js"
export * from "./detailIngameFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37893a7c",
  null
  
)

export default component.exports